// removed by extract-text-webpack-plugin
module.exports = {"Span":"Skills__Span__3VCNf","Item":"Skills__Item__1zU4a","SubHead":"Skills__SubHead__1bIqw","codeconSkills":"Skills__codeconSkills__3ObYu","Skill":"Skills__Skill__1n3Tr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Resume/Skills/Skills.css
// module id = 121
// module chunks = 0